<!--
 * @Description: 活动内容 -- PC端
 * @Author: xiuwen
 * @Date: 2024-12-25 16:02:38
 * @LastEditors: xiuwen
 * @LastEditTime: 2025-06-24 11:24:41
-->
<template>
	<section class="pc-page">
		<h2 class="pc-card-title">活動內容</h2>
		<div class="pc-swiper">
			<div class="swiper-wrapper">
				<div class="swiper-slide" v-for="item in data" :key="item.id">
					<img :src="item.cover_cc || item.cover" />
				</div>
			</div>
			<div class="swiper-pagination"></div>
			<img class="swiper-button-prev" src="~/assets/images/pc/prev.png" alt="" />
			<img class="swiper-button-next" src="~/assets/images/pc/next.png" alt="" />
		</div>
	</section>
</template>

<script setup>
import { nextTick } from "vue";
import { watchOnce } from "@vueuse/core";
import { Swiper, Pagination, Navigation, Autoplay } from "swiper";
import "~/assets/swiper/common-modules.js";

const props = defineProps({
	data: {
		type: Object,
		default: () => ({}),
	},
});

const initSwiper = () => {
	new Swiper(".pc-swiper", {
		modules: [Pagination, Navigation, Autoplay],
		loop: true,
		autoplay: {
			delay: 5000,
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
	});
};

watchOnce(
	() => props.data,
	() => {
		nextTick(() => {
			initSwiper();
		});
	},
	{
		immediate: true,
	}
);
</script>

<style lang="scss" scoped>
.pc-page {
	padding: 0 60px;
	margin-top: 48px;
	font-family: PingFang SC;
}
.pc-card-title {
	margin: 0 20px;
	font-weight: 400;
	font-size: 32px;
	color: #1f2329;
}
.pc-swiper {
	margin-top: 24px;
	width: 100%;
	position: relative;
	overflow: hidden;

	.swiper-slide {
		width: 100%;

		img {
			width: 100%;
			object-fit: cover;
			cursor: pointer;
			border-radius: 8px;
		}
	}

	.swiper-pagination {
		position: absolute;
		bottom: -23px;
	}

	:deep(.swiper-pagination-bullet) {
		width: 50px;
		height: 10px;
		background: rgba(93, 54, 7);
		border-radius: 0;
	}

	:deep(.swiper-pagination-bullet-active) {
		width: 50px;
		height: 10px;
		background: #9d4e14;
	}

	.swiper-button-prev,
	.swiper-button-next {
		margin: -32px 40px 0;
		width: 64px;
		height: 64px;
	}
}
</style>
